export const HIMS_DEVELOPER_CODE = 'hims_developer_code';
export const HIMS_PROJECT_DEVELOPMENT_ID = 'hims_project_development_id';
export const HIMS_UNIT_NUMBER = 'hims_unit_number';
export const HIMS_COMPONENT_ID = 'hims_component_id';
export const HIMS_LOT_PT = 'hims_lot_pt';
export const HIMS_LOT_POSITION = 'hims_lot_position';
export const HIMS_STRATA_PETAK_TANAH = 'hims_strata_petak_tanah';
export const HIMS_STRATA_MENARA = 'hims_strata_menara';
export const HIMS_STRATA_TINGKAT = 'hims_strata_tingkat';
export const HIMS_STRATA_JP = 'hims_strata_jp';
export const HIMS_STRATA_PETAK_AKSESORI = 'hims_strata_petak_aksesori';
export const HIMS_STRATA_JADUAL_AKSESORI = 'hims_strata_jadual_aksesori';

export const HIMS_STRATA_UNIT_FIELDS = [
  HIMS_STRATA_PETAK_TANAH,
  HIMS_STRATA_MENARA,
  HIMS_STRATA_TINGKAT,
  HIMS_STRATA_JP,
  HIMS_STRATA_PETAK_AKSESORI,
  HIMS_STRATA_JADUAL_AKSESORI,
];

export const HIMS_UNIT_MAIN_FIELDS = [
  HIMS_DEVELOPER_CODE,
  HIMS_PROJECT_DEVELOPMENT_ID,
  HIMS_UNIT_NUMBER,
  HIMS_COMPONENT_ID,
];

export const HIMS_UNIT_FIELDS = [
  ...HIMS_UNIT_MAIN_FIELDS,
  HIMS_LOT_PT,
  HIMS_LOT_POSITION,
  ...HIMS_STRATA_UNIT_FIELDS,
];

export const HIMS_LOT_POSITION_OPTIONS = [
  { text: 'Intermediate', value: 'I', description: 'Unit Tengah' },
  { text: 'End Lot', value: 'E', description: 'Unit Hujung' },
  { text: 'Corner Lot', value: 'C', description: 'Unit Sudut' },
  { text: 'Highrise', value: 'T', description: 'Bertingkat' },
  { text: 'Show Unit', value: 'S', description: 'Unit Pameran' },
];

export const HIMS_BOOKING_SYNC_STATUSES = [
  { text: 'Success', value: 'hims-success', name: 'success' },
  { text: 'Pending Sync', value: 'hims-pending', name: 'pending' },
  { text: 'Failed', value: 'hims-failed', name: 'failed' },
];

export const HIMS_STRATA_OPTIONS = [
  { text: 'Yes', value: 'yes' },
  { text: 'No', value: 'no' },
];

export const HIMS_SPA_LAWYER_REP_OPTIONS = [
  { text: 'Developer', value: 'developer' },
  { text: 'Purchaser', value: 'purchaser' },
];



// WEBPACK FOOTER //
// ./src/constants/hims.js